import { setInterceptorsToAPI } from '@/shared/api';

const initApiInterceptors = () => {
  setInterceptorsToAPI();
};

export { initApiInterceptors };
